/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ListRouteImport } from './routes/list'
import { Route as NewRouteImport } from './routes/new'
import { Route as EditIndexRouteImport } from './routes/edit/index'
import { Route as EditResumeIdRouteImport } from './routes/edit/$resumeId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ListRoute = ListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EditIndexRoute = EditIndexRouteImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => rootRouteImport,
} as any)
const EditResumeIdRoute = EditResumeIdRouteImport.update({
  id: '/edit/$resumeId',
  path: '/edit/$resumeId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/list': typeof ListRoute
  '/new': typeof NewRoute
  '/edit/$resumeId': typeof EditResumeIdRoute
  '/edit/': typeof EditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/list': typeof ListRoute
  '/new': typeof NewRoute
  '/edit/$resumeId': typeof EditResumeIdRoute
  '/edit': typeof EditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/list': typeof ListRoute
  '/new': typeof NewRoute
  '/edit/$resumeId': typeof EditResumeIdRoute
  '/edit/': typeof EditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/list' | '/new' | '/edit/$resumeId' | '/edit/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/list' | '/new' | '/edit/$resumeId' | '/edit'
  id: '__root__' | '/' | '/list' | '/new' | '/edit/$resumeId' | '/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ListRoute: typeof ListRoute
  NewRoute: typeof NewRoute
  EditResumeIdRoute: typeof EditResumeIdRoute
  EditIndexRoute: typeof EditIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/list': {
      id: '/list'
      path: '/list'
      fullPath: '/list'
      preLoaderRoute: typeof ListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit/': {
      id: '/edit/'
      path: '/edit'
      fullPath: '/edit/'
      preLoaderRoute: typeof EditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit/$resumeId': {
      id: '/edit/$resumeId'
      path: '/edit/$resumeId'
      fullPath: '/edit/$resumeId'
      preLoaderRoute: typeof EditResumeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ListRoute: ListRoute,
  NewRoute: NewRoute,
  EditResumeIdRoute: EditResumeIdRoute,
  EditIndexRoute: EditIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
